module.exports = __webpack_public_path__ + "img/vue2-corpsavant_noir.965e71b7.png";